<div class="full-width" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
    <div fxLayout="row">
      <span class="subtitle-default">Sub-leases</span>
      @if (createSubLeaseOpen) {
        <div fxLayoutGap="10px" fxFlexOffset="30px">
          <button (click)="createSubLeaseOpen = false" class="button-action" mat-flat-button [disabled]="loader.loading$ | async">
            <div class="button-text">Cancel</div>
          </button>
        </div>
      } @else {
        <div fxLayoutGap="10px" fxFlexOffset="30px">
          <button (click)="createSubLease()" class="button-action" mat-flat-button [disabled]="loader.loading$ | async">
            <div class="button-text">Add</div>
          </button>
        </div>
      }
    </div>
  </div>

  @if (createSubLeaseOpen) {
    <div class="full-width pt-3">
      <app-manage-sublease-booking [offering]="offering"
                                   [editType]="'new'"
                                   [parentLease]="parentLease"
                                   [retailerLookupOptions]="retailerLookupOptions()"
                                   (bookingSubmitted)="reloadSubLeaseData($event)"
      ></app-manage-sublease-booking>
    </div>
  } @else {
    <div fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlexOffset="20px"
           class="fx-gap-20" [formGroup]="filterForm">
        <mat-button-toggle-group formControlName="leaseStatus" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Lease Status</mat-label>
          @for (status of leaseStatuses; track status) {
            <mat-button-toggle [value]="status">{{ utils.displayStatus(status) }}</mat-button-toggle>
          }
        </mat-button-toggle-group>

        <mat-button-toggle-group formControlName="tradingOutsideOfLeasePeriod" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Term Status</mat-label>
          <mat-button-toggle [value]="false">In Term</mat-button-toggle>
          <mat-button-toggle [value]="true">Out of Term</mat-button-toggle>
        </mat-button-toggle-group>

        <mat-button-toggle-group formControlName="expiresIn" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Expires In</mat-label>
          <mat-button-toggle [value]="30">30 Days</mat-button-toggle>
          <mat-button-toggle [value]="60">60 Days</mat-button-toggle>
          <mat-button-toggle [value]="90">90 Days</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="radius-10 mat-elevation-z3 bg-white" fxLayout="column" fxFlexOffset="10px">
        <app-crud-table title="Lease Sub-leases"
                        [tableData]="filteredLeaseData"
                        [loading$]="loader.loading$"
                        [modelType]="CrudLease"
                        [showColumns]="displayedColumns"
                        [maxPageSize]="pageSize"
                        [showLoadMore]="true"
                        (reloadData)="loadInitialLeaseData()"
                        (loadData)="loadMoreLeases()"
                        (rowSelected)="openLeaseViewTab($event)">
        </app-crud-table>
      </div>
    </div>
  }

</div>
